export const constants = [
  {
    key: 'CREATE_SUCCESS',
    value: 'problems.statusFlows.messages.createSuccess'
  },
  { key: 'CREATE_ERROR', value: 'common.commonMessages.genericRequestError' },
  {
    key: 'DELETE_SUCCESS',
    value: 'problems.statusFlows.messages.deleteSuccess'
  },
  { key: 'DELETE_ERROR', value: 'common.commonMessages.genericRequestError' },
  {
    key: 'UPDATE_SUCCESS',
    value: 'problems.statusFlows.messages.updateSuccess'
  },
  { key: 'UPDATE_ERROR', value: 'common.commonMessages.genericRequestError' },
  { key: 'LIST_ERROR', value: 'common.commonMessages.genericRequestError' }
];
